var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('div',{staticClass:"view project-results"},[_c('project-results',{attrs:{"project":_vm.project}})],1):(_vm.error)?_c('div',{staticClass:"view error"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }